import { useIsBehindFeatureFlag } from "./useFeatureFlag";

export const useShowElectricalEnergyPrice = () => {
  return useIsBehindFeatureFlag("electrical_energy_price");
};

export const useShowMaterialOverrides = () => {
  return useIsBehindFeatureFlag("material_overrides");
};
